<template>
  <modal v-bind="$attrs" v-on="$listeners">
    <h2>{{product.name}}</h2>
    <div v-html="product.text"/>

    <template v-if="product.benefits && product.benefits.length">
      <hr>
      <h6>{{$t('settings.products.labels.benefits')}}</h6>
      <div class="d-flex flex-column mb-4">
        <div v-for="benefit in product.benefits"
             :key="benefit.key"
             class="d-flex align-items-center py-1">
          <component :is="benefit.icon"/>
          <span class="ml-1">{{benefit.name}}</span>
        </div>
      </div>
    </template>

    <base-button @click="onBuyClick">
      {{$t('generic.buyNow')}}
    </base-button>
  </modal>
</template>

<script>
  import * as icons from 'vue-feather-icons';

  export default {
    name: "product-details-modal",
    components: {
      ...icons
    },
    props: {
      product: Object
    },
    methods: {
      onBuyClick() {
        this.$emit('buy-click');
      }
    }
  }
</script>
